import { ActionTypes } from "../constants";
import { combineReducers } from "redux";

const reducePDPs = (state = [], action) => {
    switch (action.type) {

        case ActionTypes.GET_PDPS_SUCCESS:
            return action.data;

        case ActionTypes.GET_PDPS_FAILURE:
            return [];

        case ActionTypes.GET_PDP_SUCCESS:
        case ActionTypes.UPDATE_PDP_SUCCESS:
            return !state
                ? [action.data]
                : [
                    ...state.filter(({id}) => Number(id) !== Number(action.data.id)),
                    action.data
                ];

        case ActionTypes.ADD_DEVELOPMENT_NEED_SUCCESS:
        case ActionTypes.UPDATE_DEVELOPMENT_NEED_SUCCESS:
            if (!state || !action.data?.pdpId) { return state; }
            const pdp = state.find(({id}) => Number(id) === Number(action.data.pdpId));
            if (!pdp) { return state; }
            return [
                ...state.filter(({id}) => Number(id) !== Number(pdp.id)),
                {
                    ...pdp,
                    developmentNeeds: [
                        ...pdp.developmentNeeds.filter(({id}) => Number(id) !== Number(action.data.id)),
                        action.data
                    ]
                }
            ];
        case ActionTypes.DELETE_DEVELOPMENT_NEED_SUCCESS:
            return state.map((pdp) => (
                {
                    ...pdp,
                    developmentNeeds: pdp.developmentNeeds.filter(({id}) => Number(id) !== Number(action.payload.id))
                }
            ));

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

const pdps = combineReducers({pdps: reducePDPs});

export default pdps;

export const getPDPs = ({pdps}) => pdps;
export const getPDP = ({pdps}, pdpId) => !pdps ? null :  pdps.find(({id}) => Number(id) === pdpId);